import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './POSTAUCT_Auction_Result_Intake_S.css';

const POSTAUCT_Auction_Result_Intake_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Post-Auction Result Intake');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/POSTAUCT_Auction_Result_Intake', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_${i}_SECTION`;
	  const headerId = `#POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [POSTAUCT_AUCTION_RESULT_INTAKE, setPOSTAUCT_AUCTION_RESULT_INTAKE] = React.useState(null);
  const [POSTAUCT_AUCTION_RESULT_INTAKE_S, setPOSTAUCT_AUCTION_RESULT_INTAKE_S] = React.useState(null);

  var Ids = [];
  for(var Ele in POSTAUCT_AUCTION_RESULT_INTAKE_S){
	  for(var Sec in POSTAUCT_AUCTION_RESULT_INTAKE_S[Ele]){
			if(Sec == "id")
				Ids.push(POSTAUCT_AUCTION_RESULT_INTAKE_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(POSTAUCT_AUCTION_RESULT_INTAKE_S[Ele]["status"]);
			else if(Array.isArray(POSTAUCT_AUCTION_RESULT_INTAKE_S[Ele][Sec]))
				  for(var Row in POSTAUCT_AUCTION_RESULT_INTAKE_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in POSTAUCT_AUCTION_RESULT_INTAKE_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE`).then((response) => {
      setPOSTAUCT_AUCTION_RESULT_INTAKE(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setPOSTAUCT_AUCTION_RESULT_INTAKE_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!POSTAUCT_AUCTION_RESULT_INTAKE_S) return <div>Loading...</div>;

 const handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S = async (data) => {
  };




  const handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE_S', JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE_S');
      setPOSTAUCT_AUCTION_RESULT_INTAKE_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3"]=value;
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["3"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("3","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
  
      
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["3"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("3","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  



const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["4"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0"]=value;
	Form_Data_onChange("4","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4"]=value;
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
  
      
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  



const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19",value,Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
  }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0"]=value;
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE_S));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE_S']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = POSTAUCT_AUCTION_RESULT_INTAKE_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Post-Auction Result Intake')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Result Intake ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0" type="text" className="form-control" placeholder="POSTAUCT Result Intake ID"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Result Intake ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Result ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1" type="text" className="form-control" placeholder="PREAUCT Auction Result ID"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Result ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2" type="text" className="form-control" placeholder="Auction Opportunity ID"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Auction Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3_Change} className="form-control" name="Auction Type"  >
						  <option value="Foreclosure">Foreclosure</option>
						  <option value="Tax Sale">Tax Sale</option>
						  <option value="Sheriff Sale">Sheriff Sale</option>
						  <option value="Bankruptcy Sale">Bankruptcy Sale</option>
						  <option value="REO Auction">REO Auction</option>
						  <option value="Private Auction">Private Auction</option>
						  <option value="Online Auction">Online Auction</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Auction Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Winning Bid USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0" type="text" className="form-control" placeholder="Winning Bid USD"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Winning Bid USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Result Date`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1" type="text" className="form-control" placeholder="Auction Result Date"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Auction Result Date`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Winning Bidder Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2" type="text" className="form-control" placeholder="Winning Bidder Name"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Winning Bidder Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Result Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0" type="text" className="form-control" placeholder="Auction Result Document Link"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Auction Result Document Link`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Result Verified`)} <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1_Change} 
					  checked={POSTAUCT_AUCTION_RESULT_INTAKE_S?.["3"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"] === "true" || POSTAUCT_AUCTION_RESULT_INTAKE_S?.["3"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Intake Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0_Change} className="form-control" name="Intake Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Completed">Completed</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Intake Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0" type="text" className="form-control" placeholder="Submitted By"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1" type="text" className="form-control" placeholder="Submitted At"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2" type="text" className="form-control" placeholder="Reviewed By"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3" type="text" className="form-control" placeholder="Reviewed At"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5" type="text" className="form-control" placeholder="Approval Notes"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Map Display Enabled`)} <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0_Change} 
					  checked={POSTAUCT_AUCTION_RESULT_INTAKE_S?.["8"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"] === "true" || POSTAUCT_AUCTION_RESULT_INTAKE_S?.["8"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Public Visibility`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1_Change} className="form-control" name="Map Public Visibility"  >
						  <option value="Exact Public Boundary">Exact Public Boundary</option>
						  <option value="Approximate Public Boundary">Approximate Public Boundary</option>
						  <option value="Hidden From Public">Hidden From Public</option>
						  <option value="Investor Only After Login">Investor Only After Login</option>
						  <option value="Accredited / Approved Investor Only">Accredited / Approved Investor Only</option>
						  <option value="Internal Only">Internal Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Public Visibility
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2_Change} className="form-control" name="Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Listing Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Map Place ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3" type="text" className="form-control" placeholder="Google Map Place ID"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Google Map Place ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Maps URL`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4" type="text" className="form-control" placeholder="Google Maps URL"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Google Maps URL`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '240ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Display Address`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5" type="text" className="form-control" placeholder="Map Display Address"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '240ch' }}>
						 {t(`Enter Map Display Address`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Latitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6" type="text" className="form-control" placeholder="Map Center Latitude"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Latitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Longitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7" type="text" className="form-control" placeholder="Map Center Longitude"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Longitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Default Zoom`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8" type="text" className="form-control" placeholder="Map Default Zoom"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Map Default Zoom`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9_Change} className="form-control" name="Boundary Type"  >
						  <option value="Point Only">Point Only</option>
						  <option value="Parcel Boundary">Parcel Boundary</option>
						  <option value="Building Footprint">Building Footprint</option>
						  <option value="Unit Boundary">Unit Boundary</option>
						  <option value="Multi-Parcel Boundary">Multi-Parcel Boundary</option>
						  <option value="Multi-Building Boundary">Multi-Building Boundary</option>
						  <option value="Development Site Boundary">Development Site Boundary</option>
						  <option value="Easement / Access Boundary">Easement / Access Boundary</option>
						  <option value="Estimated Boundary">Estimated Boundary</option>
						  <option value="Confidential Boundary">Confidential Boundary</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10_Change} className="form-control" name="Boundary Source"  >
						  <option value="Google Maps">Google Maps</option>
						  <option value="Manual Pin">Manual Pin</option>
						  <option value="County GIS Parcel">County GIS Parcel</option>
						  <option value="Assessor Parcel Map">Assessor Parcel Map</option>
						  <option value="Survey">Survey</option>
						  <option value="Title Report">Title Report</option>
						  <option value="Deed Legal Description">Deed Legal Description</option>
						  <option value="KML / KMZ Upload">KML / KMZ Upload</option>
						  <option value="GeoJSON Upload">GeoJSON Upload</option>
						  <option value="Broker / Seller Provided">Broker / Seller Provided</option>
						  <option value="Auction Source">Auction Source</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Verification Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11_Change} className="form-control" name="Boundary Verification Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Unverified">Unverified</option>
						  <option value="Auto-Geocoded">Auto-Geocoded</option>
						  <option value="Manually Drawn">Manually Drawn</option>
						  <option value="Needs Review">Needs Review</option>
						  <option value="Verified by Platform">Verified by Platform</option>
						  <option value="Verified by Survey">Verified by Survey</option>
						  <option value="Verified by Title / County Record">Verified by Title / County Record</option>
						  <option value="Disputed">Disputed</option>
						  <option value="Hidden / Confidential">Hidden / Confidential</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Verification Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Geometry Format`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12_Change} className="form-control" name="Boundary Geometry Format"  >
						  <option value="Point">Point</option>
						  <option value="Bounding Box">Bounding Box</option>
						  <option value="Polygon GeoJSON">Polygon GeoJSON</option>
						  <option value="MultiPolygon GeoJSON">MultiPolygon GeoJSON</option>
						  <option value="FeatureCollection GeoJSON">FeatureCollection GeoJSON</option>
						  <option value="WKT">WKT</option>
						  <option value="KML / KMZ">KML / KMZ</option>
						  <option value="Encoded Polyline">Encoded Polyline</option>
						  <option value="Image Overlay Reference">Image Overlay Reference</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Geometry Format
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary GeoJSON`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13" type="text" className="form-control" placeholder="Boundary GeoJSON"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary GeoJSON`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary WKT`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14" type="text" className="form-control" placeholder="Boundary WKT"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary WKT`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '500ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Bounding Box`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15" type="text" className="form-control" placeholder="Boundary Bounding Box"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '500ch' }}>
						 {t(`Enter Boundary Bounding Box`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Parcel ID List`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16" type="text" className="form-control" placeholder="Parcel ID List"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Parcel ID List`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Legal Description Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17" type="text" className="form-control" placeholder="Legal Description Link"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Legal Description Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Survey Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18" type="text" className="form-control" placeholder="Survey Document Link"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Survey Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Boundary Last Verified Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19" type="date"   
							onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19_Change} style={{ borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Boundary Last Verified Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Verified By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20" type="text" className="form-control" placeholder="Boundary Verified By"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Boundary Verified By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Disclaimer`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21" type="text" className="form-control" placeholder="Map Disclaimer"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Map Disclaimer`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0"   onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`POSTAUCT Result Intake ID`)}</th>
                        <th>{t(`PREAUCT Auction Result ID`)}</th>
                        <th>{t(`Auction Opportunity ID`)}</th>
                        <th>{t(`Auction Type`)}</th>
                        <th>{t(`Winning Bid USD`)}</th>
                        <th>{t(`Auction Result Date`)}</th>
                        <th>{t(`Winning Bidder Name`)}</th>
                        <th>{t(`Auction Result Document Link`)}</th>
                        <th>{t(`Result Verified`)}</th>
                        <th>{t(`Intake Status`)}</th>
                        <th>{t(`Submitted By`)}</th>
                        <th>{t(`Submitted At`)}</th>
                        <th>{t(`Reviewed By`)}</th>
                        <th>{t(`Reviewed At`)}</th>
                        <th>{t(`Approval Status`)}</th>
                        <th>{t(`Approval Notes`)}</th>
                        <th>{t(`Map Display Enabled`)}</th>
                        <th>{t(`Map Public Visibility`)}</th>
                        <th>{t(`Map Listing Status`)}</th>
                        <th>{t(`Google Map Place ID`)}</th>
                        <th>{t(`Google Maps URL`)}</th>
                        <th>{t(`Map Display Address`)}</th>
                        <th>{t(`Map Center Latitude`)}</th>
                        <th>{t(`Map Center Longitude`)}</th>
                        <th>{t(`Map Default Zoom`)}</th>
                        <th>{t(`Boundary Type`)}</th>
                        <th>{t(`Boundary Source`)}</th>
                        <th>{t(`Boundary Verification Status`)}</th>
                        <th>{t(`Boundary Geometry Format`)}</th>
                        <th>{t(`Boundary GeoJSON`)}</th>
                        <th>{t(`Boundary WKT`)}</th>
                        <th>{t(`Boundary Bounding Box`)}</th>
                        <th>{t(`Parcel ID List`)}</th>
                        <th>{t(`Legal Description Link`)}</th>
                        <th>{t(`Survey Document Link`)}</th>
                        <th>{t(`Boundary Last Verified Date`)}</th>
                        <th>{t(`Boundary Verified By`)}</th>
                        <th>{t(`Map Disclaimer`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {POSTAUCT_AUCTION_RESULT_INTAKE_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3"]} </td>
						<td>{e["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default POSTAUCT_Auction_Result_Intake_S;  